import {PriceModel} from '../Price.model';
import {BreakdownModel} from './Breakdown.model';

export class PricingModel {
  public unitPrice: PriceModel;
  public totalPrice: PriceModel;
  public priceUndetermined: boolean;
  public breakdown: BreakdownModel;

  constructor(params: PricingModel) {
    this.unitPrice = params.unitPrice;
    this.totalPrice = params.totalPrice;
    this.priceUndetermined = params.priceUndetermined;
    this.breakdown = params.breakdown;
  }
  public static fromCartV1({
    unitPrice,
    totalPrice,
    priceUndetermined,
    comparePrice,
    comparePriceByQuantity,
    basePrice,
    totalModifiersPrice,
  }: {
    unitPrice: PriceModel;
    totalPrice: PriceModel;
    priceUndetermined: boolean;
    comparePrice?: PriceModel;
    comparePriceByQuantity?: PriceModel;
    basePrice?: PriceModel;
    totalModifiersPrice?: PriceModel;
  }) {
    return new PricingModel({
      unitPrice,
      totalPrice,
      priceUndetermined,
      breakdown: BreakdownModel.fromCartV1({comparePrice, comparePriceByQuantity, basePrice, totalModifiersPrice}),
    });
  }
}
